export const moveLocationSearchField = () => {
    if (!document.body.classList.contains("page-jobs-near-you")) return;

    const searchWidget: HTMLDivElement | null = document.querySelector(".page-jobs-near-you__hero-search");
    const inputs: HTMLDivElement | null = (searchWidget?.querySelector(".attrax-search-widget__form-items") ?? null);
    const location: HTMLDivElement | null = (searchWidget?.querySelector(".location-filter") ?? null);

    if (!inputs || !location || inputs.contains(location)) return;

    inputs.append(location);
};
